<template>
     <v-container fluid>
        <v-card flat>
            <v-card-title>
                <v-toolbar>
                    <v-icon color="blue">receipt</v-icon>
                    <v-toolbar-title class="font-weight-light"> 
                        <v-row>
                            <v-col>
                                <div>&nbsp; Resultado Envíos de Débitos</div>
                            </v-col>
                        </v-row>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.stop="hideActiveTask"><v-icon>close</v-icon></v-btn>
                </v-toolbar>            
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="3">
                        Entidad
                    </v-col>
                    <v-col>
                        <span class="body-2">{{model.entidadFinanciera}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        C.B.U.
                    </v-col>
                    <v-col>
                        <span class="body-2">{{model.cbu}}</span>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                
                <v-row>
                    <v-col >
                        <v-checkbox label="Incluir Débitos" v-model="incluirDebitosLocal" ></v-checkbox>
                    </v-col>

                    <v-col >
                        <v-checkbox label="Incluir Rechazos" v-model="incluirRechazosLocal" ></v-checkbox>
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row>
                    <v-col>
                        <v-data-table dense
                            :headers="headers"
                            :items="list"
                            :loading="loading"
                            class="elevation-1"                        
                        >
                        <template v-slot:item="{ item,isSelected, select }">
                            <tr>                            
                                <td class="text-xs-left caption"><v-chip dark small :color="item.resultado == 'Debitado'?'green':'red'">{{ item.resultado }}</v-chip> </td>

                                <td class="text-xs-left caption">{{ item.formatoEnvio }}</td>
                                <td class="text-xs-left caption">{{ item.fechaEnvio | dateParse() | dateFormat('DD-MM-YY')}}</td>
                                
                                <td class="text-xs-left caption">{{ item.referenciaEnvioId }}</td>
                                <td class="text-xs-left caption">{{ item.fechaProceso |dateParse() | dateFormat('DD-MM-YY') }}</td>
                                
                                <td class="text-xs-left caption">{{ item.errores +  (item.erroresProceso? item.erroresProceso:'')  }}</td>
                            </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>

        </v-card>
     </v-container>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'


import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data () {
        return {
            loading: false,
            model: {},
            headers: [ // definición de columnas                        
                { text: 'Resultado', value: 'resultado'},
                { text: 'Formato', value: 'formatoEnvio'},
                { text: 'Fecha Env.', value: 'fechaEnvio'},
                { text: 'Referencia Id', value: 'referenciaEnvioId'},
                { text: 'Fecha Proceso', value: 'fechaProceso'},
                { text: 'Errores', value: 'errores'},
            ],
            list:[],
            incluirDebitosLocal: true,
            incluirRechazosLocal: true,
        }
    },
    props:{
        PersonaId: {
            type: String,
        },
        CuentaBancoId: {
            type: String,
        },
        TipoDeuda: {
            type: Number,
        },
        DeudaId: {
            type: String,
        },                
        IncluirDebitos: {
            type: Boolean,
        },
        IncluirRechazos: {
            type: Boolean,
        },
    },
    watch:{
        CuentaBancoId: async function(){            
            if(this.CuentaBancoId){
                this.incluirDebitosLocal = this.IncluirDebitos;
                this.incluirRechazosLocal = this.IncluirRechazos;
                
                await this.loadDatosCuentaBanco();
                await this.load();
            }
        },
        incluirDebitosLocal: function(){     
            this.load();   
        },
        incluirRechazosLocal: function(){     
            this.load();   
        }
        
    },
    created: function(){
        this.incluirDebitosLocal = this.IncluirDebitos;
        this.incluirRechazosLocal = this.IncluirRechazos;

        this.loadDatosCuentaBanco();
        this.load();
    },
    methods:{
        ...mapMutations(["hideActiveTask","hideActiveSubTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
        async load(){
            console.log(this.CuentaBancoId);
            
            this.loading = true
            try {
                var result = await http.get('cuentasbanco/listresultadosenviodebitos'
                + '?personaId='+ this.PersonaId
                + '&cuentaBancoId='+ this.CuentaBancoId
                + '&tipoDeuda='+ this.TipoDeuda
                + '&deudaId='+ this.DeudaId
                + '&incluirDebitos='+ this.incluirDebitosLocal
                + '&incluirRechazos='+ this.incluirRechazosLocal
                ); 

                this.list = result.list;

            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false
        },
        async loadDatosCuentaBanco(){
            console.log(this.CuentaBancoId);
            
            this.loading = true
            try {
                var result = await http.get('cuentasbanco/' + this.CuentaBancoId);
                this.model = result;
                console.log(this.model);

            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false
        },

    }
}
</script>